import { Link } from '@tanstack/react-router'
import type { BreadcrumbProps } from '../Types'
import { formatLabel } from '../imageUrl'

const Breadcrumb = ({ items = [] }: BreadcrumbProps) => {
  const flightsIsActive = items.length === 0

  return (
    <ol className="breadcrumb container d-none d-sm-flex">
      <li>
        <a href="/" className="has-icon text-dark">
          <i className="icon-home_inverted glyph-md"></i>
          <span className="ps-1">Home</span>
        </a>
      </li>
      <li className={flightsIsActive ? 'active' : undefined}>
        {flightsIsActive
          ? 'Flights'
          : <Link to="/" className="text-dark">Flights</Link>
        }
      </li>
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        return (
          <li key={i} className={isLast ? 'active' : undefined}>
            {!isLast && item.to
              ? <Link to={item.to as any} params={item.params as any} className="text-dark">{formatLabel(item.label)}</Link>
              : formatLabel(item.label)
            }
          </li>
        )
      })}
    </ol>
  )
}

export default Breadcrumb
